import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import Header from "../common/Header";

export default function EmailConfirmed() {
  const { t } = useTranslation();

  return (
    <>
      <Container maxWidth="sm" sx={{ pb: 3 }}>
        <Box
          sx={{
            mt: 4,
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            p: 4,
            borderRadius: 0,
            boxShadow: 1,
          }}
        >
          <Typography variant="h5" gutterBottom>
            {t("email_confirmed.title")}
          </Typography>
          <Typography variant="body1">
            {t("email_confirmed.subtitle")}
          </Typography>
          <Typography variant="body2" sx={{ mt: 2, color: "#555" }}>
            {t("email_confirmed.instructions")}
          </Typography>
        </Box>
      </Container>
    </>
  );
}
